var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFi24Hours48 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.447,
    height: 33.009,
    viewBox: "0 0 37.447 33.009",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(0 -30.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M36.575,130.595h-.918V114.456a.549.549,0,1,0-1.1,0v16.139H29.973a.549.549,0,0,0,0,1.1h6.375v.232a1.426,1.426,0,0,1-1.425,1.425H2.524A1.426,1.426,0,0,1,1.1,131.926v-.232H27.632a.549.549,0,0,0,0-1.1H2.889V108.889a.726.726,0,0,1,.725-.725h18a.549.549,0,0,0,0-1.1h-18a1.826,1.826,0,0,0-1.824,1.824v21.706H.873a.874.874,0,0,0-.873.873v.458a2.526,2.526,0,0,0,2.524,2.524h32.4a2.526,2.526,0,0,0,2.524-2.524v-.458A.874.874,0,0,0,36.575,130.595Z",
    transform: "translate(0 -71.153)",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M72.065,138.164a.549.549,0,1,0,0-1.1H54.984a.549.549,0,0,0-.549.549v19.134a.549.549,0,0,0,.549.549h4.76a.549.549,0,1,0,0-1.1h-4.21V138.164Z",
    transform: "translate(-50.447 -98.955)",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M162.66,200.874v-3.633a1.81,1.81,0,0,0-1.808-1.808h-3.447l-1.013-.333a.8.8,0,0,0-1.045.756v5.017A3.658,3.658,0,0,0,157.111,204v.606l-2.413,2a2.265,2.265,0,0,0-.82,1.748v1.586h-1.966a.549.549,0,0,0,0,1.1h21.271a.549.549,0,0,0,.549-.549V196.057a.549.549,0,1,0-1.1,0v13.888h-8.518v-1.586a2.265,2.265,0,0,0-.82-1.748l-2.413-2v-.6a3.658,3.658,0,0,0,1.779-3.136Zm-5.515-4.369a.548.548,0,0,0,.172.027h3.535a.71.71,0,0,1,.709.709v1.106h-5.115v-2.072Zm-.7,2.942h5.115v1.428a2.557,2.557,0,1,1-5.115,0v-1.428Zm6.569,8.913v1.586h-8.039v-1.586a1.169,1.169,0,0,1,.424-.9l2.064-1.714a1.882,1.882,0,0,0,3.063,0l2.064,1.714A1.17,1.17,0,0,1,163.016,208.359Zm-3.234-3.713a.786.786,0,0,1-1.572,0v-.2a3.635,3.635,0,0,0,1.572,0v.2Z",
    transform: "translate(-140.273 -152.701)",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M328.708,30.287h-8.1a3.044,3.044,0,0,0-3.041,3.041v8.89a.936.936,0,0,0,.617.886.954.954,0,0,0,.332.06.936.936,0,0,0,.713-.331l.966-1.126h3.292a.549.549,0,1,0,0-1.1h-3.545a.549.549,0,0,0-.417.192l-.859,1V33.328a1.944,1.944,0,0,1,1.942-1.942h8.1a1.944,1.944,0,0,1,1.942,1.942v5.339a1.944,1.944,0,0,1-1.942,1.942h-2.879a.549.549,0,1,0,0,1.1h2.879a3.044,3.044,0,0,0,3.041-3.041V33.328A3.044,3.044,0,0,0,328.708,30.287Z",
    transform: "translate(-294.302)",
    fill: "#0d47a1"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFi24Hours48, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fi-24-hours-48.1c031364.svg";
export { ForwardRef as ReactComponent };